import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e639335")

_pushScopeId("data-v-0e639335")
const _hoisted_1 = { class: "asset t-center" }
const _hoisted_2 = { class: "d-f" }
const _hoisted_3 = { class: "col flex-1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Balance")
const _hoisted_5 = { class: "col flex-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Equity")
const _hoisted_7 = { class: "col flex-1" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Free Margin")
const _hoisted_9 = { class: "d-f mt-16" }
const _hoisted_10 = { class: "col flex-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Margin Used")
const _hoisted_12 = { class: "col flex-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Margin Level")
const _hoisted_14 = {
  key: 0,
  class: "f-medium"
}
const _hoisted_15 = { class: "col flex-1" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Floating P/L")
const _hoisted_17 = { class: "d-f mt-16" }
const _hoisted_18 = { class: "col flex-1" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("My Credit")
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "col flex-1" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "d-f px-16 c-danger f-sm"
}
const _hoisted_23 = {
  key: 0,
  class: "px-16 mb-16"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Top up the demo account")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_money = _resolveComponent("money")
  const _component_Icon = _resolveComponent("Icon")
  const _component_AccountRelated = _resolveComponent("AccountRelated")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_t, {
          as: "p",
          path: "trade_4",
          class: "label"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_money, {
          as: "p",
          class: "f-medium",
          v: _ctx.account.balance
        }, null, 8, ["v"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_t, {
          as: "p",
          path: "trade_5",
          class: "label"
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_money, {
          as: "p",
          class: "f-medium",
          v: _ctx.account.equity
        }, null, 8, ["v"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_t, {
          as: "p",
          path: "trade_6",
          class: "label"
        }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_money, {
          as: "p",
          class: "f-medium",
          v: _ctx.account.freeMargin
        }, null, 8, ["v"])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_t, {
          as: "p",
          path: "trade_7",
          class: "label"
        }, {
          default: _withId(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_money, {
          as: "p",
          class: "f-medium",
          v: _ctx.account.useMargin
        }, null, 8, ["v"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_t, {
          as: "p",
          path: "trade_8",
          class: "label"
        }, {
          default: _withId(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        (_ctx.account.marginRatio === '0')
          ? (_openBlock(), _createBlock("p", _hoisted_14, "--"))
          : (_openBlock(), _createBlock("p", {
              key: 1,
              class: ["f-medium", {'c-danger': Number(_ctx.account.marginRatio) < 100}]
            }, _toDisplayString(_ctx.account.marginRatio) + "%", 3))
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_t, {
          as: "p",
          path: "trade_9",
          class: "label"
        }, {
          default: _withId(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _createVNode(_component_money, {
          as: "p",
          class: ["f-medium c-success", {'c-danger': _ctx.account.plFeeAmount < 0}],
          v: _ctx.account.plFeeAmount
        }, null, 8, ["v", "class"])
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_t, {
          as: "p",
          path: "credit_2",
          class: "label"
        }, {
          default: _withId(() => [
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_money, {
          as: "p",
          class: "f-medium",
          v: _ctx.account.validCreditAmount
        }, null, 8, ["v"])
      ]),
      _hoisted_20,
      _hoisted_21
    ]),
    _createVNode(_component_AccountRelated, { "use-in-real": "" }, {
      default: _withId(() => [
        (_ctx.stickAlertFlag)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _createVNode(_component_Icon, {
                name: "warn",
                sm: ""
              }),
              _createVNode(_component_t, {
                as: "p",
                path: "trade_32",
                class: "flex-1 t-left pl-8",
                style: {"font-style":"italic"}
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_AccountRelated, { "use-in-demo": "" }, {
      default: _withId(() => [
        (_ctx.showTopUp)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _createVNode(_component_Button, {
                class: "success br-sm top-btn",
                onClick: _ctx.topUpClick,
                progress: _ctx.progress
              }, {
                default: _withId(() => [
                  _createVNode(_component_t, { path: "trade_33" }, {
                    default: _withId(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick", "progress"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
})